/** @format */
import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PlanValidationResult } from 'common-typescript';
import { CreditRange, DegreeProgramme, GroupingModule, Module, StudyModule } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { ModuleStateObject, PlanData, PlanStateObject } from '../../service/plan-state.service';
import { getFudisHeadingSize } from '../plan-structure-utils';

@Component({
    selector: 'sis-plan-structure-module',
    templateUrl: './plan-structure-module.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureModuleComponent implements OnChanges {
    @Input({ required: true }) module: GroupingModule | StudyModule | DegreeProgramme;
    @Input() planValidationResult: PlanValidationResult;
    @Input({ required: true }) planStateObject: PlanStateObject;
    @Input({ required: true }) planData: PlanData;
    @Input() isImplicit: boolean;
    @Input() isParentModule?: Module;
    @Input({ required: true }) headingLevel: number;

    targetCredits: CreditRange;
    moduleStateObject: ModuleStateObject;

    constructor(@Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private planActionsService: PlanActionsService) {}

    ngOnChanges(changes: SimpleChanges) {
        this.moduleStateObject = _.get(this.planStateObject?.modules, this.module.id);
        if (this.module?.type !== 'GroupingModule') {
            this.targetCredits = this.module.targetCredits;
        }
    }

    openModuleInfoModal(event?: MouseEvent) {
        event?.preventDefault();
        event?.stopPropagation();
        this.planActionsService.openModuleInfoModal(this.module);
    }

    openModule() {
        this.planActionsService.openModule(this.module);
    }

    isDegreeProgrammeModule() {
        return this.module.type === 'DegreeProgramme';
    }

    getHeadingSize() {
        return getFudisHeadingSize(this.headingLevel);
    }

    useBackgroundColor() {
        return this.module.type === 'StudyModule' || this.module.type === 'GroupingModule';
    }
}
